import EventEmitter from './base/event-emitter';

export enum AuthEventName {
  KeycloakToken = 'KEYCLOAK_TOKEN',
  LogoutKeycloakUser = 'LOGOUT_KEYCLOAK_USER',
}

class AuthEventsService extends EventEmitter {
  public emitKeycloakToken = (keycloakToken?: string) => {
    this.emit(AuthEventName.KeycloakToken, keycloakToken);
  };

  public emitLogoutKeycloakUser = (flag: boolean) => {
    this.emit(AuthEventName.LogoutKeycloakUser, flag);
  };

  public subscribeToLogoutKeycloakUser = (
    callback: (...args: any[]) => any
  ) => {
    this.subscribe(AuthEventName.LogoutKeycloakUser, callback);
  };

  public subscribeToKeycloakToken = (callback: (...args: any[]) => any) => {
    this.subscribe(AuthEventName.KeycloakToken, callback);
  };
}

export default new AuthEventsService();
